// src/components/contact/ContactForm.js
import React, { useState } from "react";
import { useWebData } from "../../Context/webDataContext";

const ContactForm = () => {
  const { postContactData } = useWebData();
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    await postContactData(formData);
    setStatus("Message sent!");
    setFormData({ name: "", mobile: "", email: "", message: "" });
  };

  return (
    <form onSubmit={handleSubmit} className="w-full rounded-lg space-y-5 mb-4">
      {/* Name */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
        <input
          type="text"
          name="name"
          placeholder="Your name"
          value={formData.name}
          onChange={handleChange}
          className="w-full rounded-md border border-gray-300 focus:ring-green-600 focus:border-green-600 py-2 px-3"
          required
        />
      </div>

      {/* Mobile Number */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Mobile Number</label>
        <input
          type="text"
          name="mobile"
          placeholder="e.g., 9191967267"
          value={formData.mobile}
          onChange={handleChange}
          className="w-full rounded-md border border-gray-300 focus:ring-green-600 focus:border-green-600 py-2 px-3"
          required
        />
      </div>

      {/* Email */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
        <input
          type="email"
          name="email"
          placeholder="e.g., abc@email.com"
          value={formData.email}
          onChange={handleChange}
          className="w-full rounded-md border border-gray-300 focus:ring-green-600 focus:border-green-600 py-2 px-3"
          required
        />
      </div>

      {/* Message */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
        <textarea
          name="message"
          placeholder="Type your message here..."
          value={formData.message}
          onChange={handleChange}
          className="w-full rounded-md border border-gray-300 focus:ring-green-600 focus:border-green-600 py-2 px-3 h-32"
          required
        ></textarea>
      </div>

      {/* Submit Button */}
      <div className="flex itmes-center justify-center lg:justify-end">
        <button
          type="submit"
          className="bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)] text-white font-medium py-2 px-6 rounded-md transition-colors hover:opacity-90"
        >
          Send Message
        </button>
      </div>
      {status && <p className="text-center text-sm mt-2">{status}</p>}
    </form>
  );
};

export default ContactForm;











// import React from "react";

// const ContactForm = () => {
//   return (
//     <form className="w-full bg-white p-8 rounded-lg shadow-lg space-y-5">
//       {/* Name */}
//       <div>
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Name
//         </label>
//         <input
//           type="text"
//           placeholder="abc"
//           className="
//             w-full rounded-md border border-gray-300
//             focus:ring-green-600 focus:border-green-600
//             py-2 px-3
//           "
//         />
//       </div>

//       {/* Mobile Number */}
//       <div>
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Mobile Number
//         </label>
//         <input
//           type="text"
//           placeholder="e.g., 9191967267"
//           className="
//             w-full rounded-md border border-gray-300
//             focus:ring-green-600 focus:border-green-600
//             py-2 px-3
//           "
//         />
//       </div>

//       {/* Email */}
//       <div>
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Email
//         </label>
//         <input
//           type="email"
//           placeholder="e.g., abc@email.com"
//           className="
//             w-full rounded-md border border-gray-300
//             focus:ring-green-600 focus:border-green-600
//             py-2 px-3
//           "
//         />
//       </div>

//       {/* Message */}
//       <div>
//         <label className="block text-sm font-medium text-gray-700 mb-1">
//           Message
//         </label>
//         <textarea
//           placeholder="Type Here..."
//           className="
//             w-full rounded-md border border-gray-300
//             focus:ring-green-600 focus:border-green-600
//             py-2 px-3 h-32
//           "
//         ></textarea>
//       </div>

//       {/* Submit Button */}
//       <div className="flex justify-end">
//         <button
//           type="submit"
//           className="
//             bg-[radial-gradient(104.71%_69.4%_at_73.87%_69.4%,_#1D9D67_0%,_#1E8157_21.75%,_#1F6546_51.09%,_#1F573E_72.69%,_#204533_100%)]
//             text-white font-medium 
//             py-2 px-6 rounded-md 
//             transition-colors
//             hover:opacity-90
//           "
//         >
//           Send Message
//         </button>
//       </div>
//     </form>
//   );
// };

// export default ContactForm;
